/*
<summary>
   This file is used to provide initial values or state to the Process Module Observables.
   Developer:Urvashi, Created Date: 21-November-2024
</summary>
*/
import { IActiveTrayListVM } from '../../models/response/IActiveTrayResponse';
const initialTrayState: IActiveTrayListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  Trays: [],
  Processes: []
};

export default initialTrayState;
